import { setDoc } from 'firebase/firestore'
import { aiPlanRef } from './hooks'

// Fans out into many small parallel calls - measured in production, one
// workout call takes ~14s for 3 keys and ~30s+ for 2 menus, and Netlify's
// synchronous function timeout is a hard 30s. So workouts go in chunks of 3
// keys and menus one per call (see generate-workouts.js / generate-menus.js's
// "keys"/"menuNumbers" params).
// Writes the merged result as this user's AI plan. Throws on failure.
const WORKOUT_CHUNKS = [
  ['A', 'B', 'C'],
  ['UpperA', 'LowerA', 'UpperB'],
  ['LowerB', 'Push', 'Pull'],
  ['Legs', 'Upper', 'Lower'],
  ['rec'],
]
const MENU_NUMBERS = [1, 2, 3, 4, 5, 6, 7]

export async function generateAndSaveAiPlan(uid, profile) {
  const postJson = async (url, body) => {
    const res = await fetch(url, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) })
    if (!res.ok) throw new Error('AI plan generation failed')
    return res.json()
  }

  const [workoutResults, menuResults] = await Promise.all([
    Promise.all(WORKOUT_CHUNKS.map((keys) => postJson('/api/generate-workouts', { profile, keys }))),
    Promise.all(MENU_NUMBERS.map((n) => postJson('/api/generate-menus', { profile, menuNumbers: [n] }))),
  ])

  const workouts = Object.assign({}, ...workoutResults.map((r) => r.workouts))
  const menus = Object.assign({}, ...menuResults.map((r) => r.menus))
  const { targetKcal, targetProtein } = menuResults[0]

  const weeklyPattern = {
    1: ['A', 'rec', 'B', 'rec', 'C', 'rec', 'rec'],
    2: ['UpperA', 'LowerA', 'rec', 'UpperB', 'LowerB', 'rec', 'rec'],
    3: ['Push', 'Pull', 'Legs', 'Upper', 'Lower', 'rec', 'rec'],
  }

  const plan = { workouts, weeklyPattern, menus, targetKcal, targetProtein, generatedAt: new Date().toISOString() }
  await setDoc(aiPlanRef(uid), plan)
  return plan
}
